import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getModosEmpleo, getUsosOrigen, removeUsos } from "../../../../../../../../redux/actions/resolucion";
import UsosTable from "./UsosTable";
import UsosFormContainer from "./form/UsosFormContainer";

const UsosTableContainer = () => {
    const dispatch = useDispatch();
    const [openUsosForm, setOpenUsosForm] = useState(false);
    const [uso, setUso] = useState();
    const usos = useSelector((state) => state.resolucion.abmSustancia.usos);

    useEffect(() => {
        dispatch(getUsosOrigen());
        dispatch(getModosEmpleo());
    }, [])

    const handleOpenForm = (uso) => {
        setUso(uso);
        setOpenUsosForm(true);
    }
    const handleDelete = (indices) => {
        dispatch(removeUsos(indices));
    }


    return (
        <>
            <UsosTable
                data={usos}
                handleOpenForm={handleOpenForm}
                handleDelete={handleDelete}
            />
            <UsosFormContainer
                open={openUsosForm}
                formValues={uso}
                handleClose={() => setOpenUsosForm(false)}

            />
        </>

    )
}

export default UsosTableContainer;